import { SpinnerService } from './../../../services/shared/spinner.service';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedService } from 'src/app/services/shared-service.service'; // Adjust path according to your project structure
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  userId: string = '';
  allNotifications: any[] = [];
  pageNumber: number = 0;
  pageSize: number = 10;
  activeTab=0;
  previousTab=0;
  checkedNotificationsList: any[] = [];
  selectAll: boolean = false;
  showContentList: any[] = [];
  maxPageSize: number = -1;
  notificationStatus: string = '';
  constructor(private sharedService: SharedService, private localStorageService: LocalStorageService,private breadcrumbService: BreadcrumbService, private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.showSpinner();
    this.breadcrumbService.setBreadcrumbs(['Dashboard','Notifications']);
    this.localStorageService.getUserDetails().subscribe(userDetails => {
      this.userId = userDetails.userId;
    });
    this.fetchNotifications(this.pageNumber, this.pageSize);
    if(window.history.state.notification) {
      this.showContent(window.history.state.notification);
    }
    this.spinnerService.hideSpinner();
  }

  fetchNotifications(pageNumber: number, pageSize: number) {
    if (pageNumber < 0) return; // Prevent infinite recursion when no data is available
  
    this.sharedService.getNotifications(this.userId, pageNumber, pageSize, this.notificationStatus)
      .subscribe(
        (response) => {
          if (response?.data) {
            this.allNotifications = response.data;
  
            if (this.allNotifications.length === 0) {
              if (pageNumber > 0) { // Ensure we don't go below page 0
                this.maxPageSize = pageNumber;
                this.fetchNotifications(pageNumber - 1, pageSize);
                this.pageNumber = Math.max(pageNumber - 1, 0);
              }
              return;
            }
  
            if (this.allNotifications.length < pageSize) {
              this.maxPageSize = pageNumber + 1;
            }
          }
        },
        (error) => {
          console.error("Error fetching notifications:", error);
        }
      );
  }
  

  checkedNotifications(event: any, notification: any){
    if(event.checked && (this.checkedNotificationsList.length === 0 || !this.checkedNotificationsList.includes(notification)) ){
      this.checkedNotificationsList.push(notification);
    }
    else{
      const index = this.checkedNotificationsList.indexOf(notification);
      if (index > -1) {
        this.checkedNotificationsList.splice(index, 1);
      }
    }
  }

  selectAllNotifications() {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.checkedNotificationsList = [...new Set(this.allNotifications)];
    } else {
      this.checkedNotificationsList = [];
    }
  }
  

  showContent(notification: any){
    // this.updateToRead(notification.id)
    if(this.showContentList.length === 0 || !this.showContentList.includes(notification.id) ){
      this.showContentList.push(notification.id);
    }
    else{
      const index = this.showContentList.indexOf(notification.id);
      if (index > -1) {
        this.showContentList.splice(index, 1);
      }
    }
  }

  changeAll(status: string) {
    const selectedIds = this.checkedNotificationsList.map(notif => notif.id).join("&ids=");
    if (!selectedIds) return; // Prevent API call if nothing is selected
  
    const url = `ids=${selectedIds}`;
    this.sharedService.changeAllNotifications(url, status).subscribe(() => {
      this.fetchNotifications(this.pageNumber, this.pageSize);
      this.checkedNotificationsList = []; // Clear selection after updating
      this.selectAll = false;
    });
  }
  

  assignNotificationStatus(index: number) {
    switch (index) {
      case 0:
        this.notificationStatus = '';
        break;
      case 1:
        this.notificationStatus = 'READ';
        break;
      case 2:
        this.notificationStatus = "UNREAD";
        break;
      default:
        break;
    }
  }

  selectTab(index: number) {
    this.pageNumber = 0;
    if (index !== this.activeTab) {
      this.maxPageSize = -1;
      this.selectAll = false;
      this.activeTab = index;
      this.previousTab = this.activeTab;
      this.assignNotificationStatus(index);
      this.fetchNotifications(this.pageNumber, this.pageSize);
    }
  }

  deleteNotification(notificationId: string) {
    this.sharedService.updateStatus(notificationId, 'DELETE').subscribe(() => {
      this.fetchNotifications(this.pageNumber, this.pageSize);
    });
  }

  nextpage() {
    this.selectAll = false;
    if (this.pageNumber + 1 >= this.maxPageSize && this.maxPageSize !== -1) {
      return;
    }
    this.pageNumber++;
    this.fetchNotifications(this.pageNumber, this.pageSize);
  }
  

  prevpage() {
    if (this.pageNumber > 0) {
      this.selectAll = false;
      this.pageNumber--;
      this.fetchNotifications(this.pageNumber, this.pageSize);
    }
  }
  

  updateToRead(notificationId: string) {
    this.sharedService.updateStatus(notificationId, 'READ').subscribe(() => {
      this.fetchNotifications(this.pageNumber, this.pageSize);
    });
  }
}
